import { useContext, useEffect, useState } from 'react';
import { A1_POWEREDBY_COLOR_PRIMARY, EVENTS_URL } from '../config';
import { useQuery } from '@apollo/client';
import { CartContext } from '../components/providers/cart';
import { AdditionTermsPageEventDocument } from '../graphql/graphql';
import { ThemeProvider } from '../ThemeProvider';
import AdditionalTermsLoading from '../components/additionalTerms/additionalTermsLoading';
import HeaderJoyComponent from '../components/common/HeaderJoy.component';
import { Container, Typography } from '@mui/joy';
import AdditionalTermsLoaded from '../components/additionalTerms/additionalTermsLoaded';
import { isReallyEmpty } from '../utils/validators';
import { formatPrimaryColor } from '../utils/formatter';

export default function AdditionalTermsPage() {
    const [errorAlert, setErrorAlert] = useState<string | null>(null);

    const { currentEventId } = useContext(CartContext);

    const { loading, data, error } = useQuery(AdditionTermsPageEventDocument, {
        variables: {
            eventId: currentEventId!,
        },
        skip: !currentEventId,
    });

    useEffect(() => {
        if (!currentEventId) {
            window.location.href = EVENTS_URL;
        }
    }, [currentEventId]);

    if (!loading && error) {
        return <>Error Loading Data</>;
    }

    const organizerThemeColor = data?.event?.organizerColor || A1_POWEREDBY_COLOR_PRIMARY;

    const organizerPrimaryColor = formatPrimaryColor(
        data?.event?.eventType,
        data?.event?.organizerType,
        organizerThemeColor
    );

    const hasAdditionalTerms =
        data?.event?.additionalTerms != null && !isReallyEmpty(data?.event?.additionalTerms);

    const hasQuestionnaire =
        (data?.event?.questionnaire && data?.event?.questionnaire?.questions.length > 0) || false;

    return (
        <ThemeProvider>
            <>
                {loading ? (
                    <>
                        <AdditionalTermsLoading />
                    </>
                ) : (
                    <Container sx={{ py: 6 }}>
                        <HeaderJoyComponent
                            hasAdditionalTerms={hasAdditionalTerms}
                            previousPage={`/${data?.event?.shortEventId}`}
                            step={hasQuestionnaire ? 3 : 2}
                            organizerPrimaryColor={organizerPrimaryColor}
                            headerTitle={'Additional Terms'}
                            setErrorAlert={setErrorAlert}
                            errorAlert={errorAlert}
                            hasQuestionnaire={hasQuestionnaire}
                        />
                        <Typography level="title-md" sx={{ mt: 0, mb: 4 }}>
                            You must agree with the terms below to complete the transaction.
                        </Typography>
                        <AdditionalTermsLoaded
                            event={data?.event}
                            setErrorAlert={setErrorAlert}
                            organizerPrimaryColor={organizerPrimaryColor}
                        />
                    </Container>
                )}
            </>
        </ThemeProvider>
    );
}
